// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
.root,
#root {
    --text-primary: #088947;
    --text-secondary: #088947;
    --text-high-em: #110c22;
    --text-med-em: #676472;
    --text-low-em: #b3b1b8;
    --icon-high-em: #4f4b5c;
    --icon-med-em: #8d8a95;
    --icon-low-em: #c6c5ca;
    --icon-disabled: #d9d8dc;
    --system-error-500: #f03d3d;
    --tc-outlines-med: #ececed;
    --tc-text-primary-bold: #3c28a4;
    --text-info: #0084ff;
    --tc-system-info-50: #e9f4ff;
    --tc-system-error-50: #fff1f1;
    --surface-info: #0084ff;
    --tc-primary-p-400: #8b75ff;
    --shadow-e-02: 0px 2px 4px -2px rgba(17, 12, 34, 0.12);
    --shadow-pressed-primary: 0px 0px 0px 4px #e2dcff,
        0px 2px 4px 0px rgba(17, 12, 34, 0.12);
    --shadow-pressed-gray: 0px 0px 0px 4px #ececed,
        0px 2px 4px 0px rgba(17, 12, 34, 0.12);
    --shadow-pressed-info: 0px 0px 0px 4px #c2e2ff,
        0px 2px 4px 0px rgba(17, 12, 34, 0.12);
    --tc-primary-p-50: #f1eeff;
    --tc-primary-p-75: #e2dcff;
    --tc-gray-g-75: #ececed;
    --tc-gray-g-25: #f8f8f8;
    --tc-system-info-75: #c2e2ff;
    --tc-system-info-25: #f5faff;
    --tc-system-info-400: #1c92ff;
    --tc-system-success-300: #4dcc8f;
    --tc-surface-high: #ececed;
    --tc-gray-g-200: #d9d8dc;
    --surface-low: #f8f8f8;
    --borderColor: #ececed;
}
`, "",{"version":3,"sources":["webpack://./src/variables.css"],"names":[],"mappings":"AAAA;;;IAGI,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,wBAAwB;IACxB,2BAA2B;IAC3B,0BAA0B;IAC1B,+BAA+B;IAC/B,oBAAoB;IACpB,4BAA4B;IAC5B,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;IAC3B,sDAAsD;IACtD;8CAC0C;IAC1C;8CAC0C;IAC1C;8CAC0C;IAC1C,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,4BAA4B;IAC5B,6BAA6B;IAC7B,gCAAgC;IAChC,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;IACtB,sBAAsB;AAC1B","sourcesContent":["body,\n.root,\n#root {\n    --text-primary: #088947;\n    --text-secondary: #088947;\n    --text-high-em: #110c22;\n    --text-med-em: #676472;\n    --text-low-em: #b3b1b8;\n    --icon-high-em: #4f4b5c;\n    --icon-med-em: #8d8a95;\n    --icon-low-em: #c6c5ca;\n    --icon-disabled: #d9d8dc;\n    --system-error-500: #f03d3d;\n    --tc-outlines-med: #ececed;\n    --tc-text-primary-bold: #3c28a4;\n    --text-info: #0084ff;\n    --tc-system-info-50: #e9f4ff;\n    --tc-system-error-50: #fff1f1;\n    --surface-info: #0084ff;\n    --tc-primary-p-400: #8b75ff;\n    --shadow-e-02: 0px 2px 4px -2px rgba(17, 12, 34, 0.12);\n    --shadow-pressed-primary: 0px 0px 0px 4px #e2dcff,\n        0px 2px 4px 0px rgba(17, 12, 34, 0.12);\n    --shadow-pressed-gray: 0px 0px 0px 4px #ececed,\n        0px 2px 4px 0px rgba(17, 12, 34, 0.12);\n    --shadow-pressed-info: 0px 0px 0px 4px #c2e2ff,\n        0px 2px 4px 0px rgba(17, 12, 34, 0.12);\n    --tc-primary-p-50: #f1eeff;\n    --tc-primary-p-75: #e2dcff;\n    --tc-gray-g-75: #ececed;\n    --tc-gray-g-25: #f8f8f8;\n    --tc-system-info-75: #c2e2ff;\n    --tc-system-info-25: #f5faff;\n    --tc-system-info-400: #1c92ff;\n    --tc-system-success-300: #4dcc8f;\n    --tc-surface-high: #ececed;\n    --tc-gray-g-200: #d9d8dc;\n    --surface-low: #f8f8f8;\n    --borderColor: #ececed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
